// nur im Browser laden
if (typeof window !== 'undefined') {
    import('bootstrap')
}